import React, { useEffect, useContext } from 'react'

import EventList from '../components/EventList'
import Section from '../components/Section'
import { PageLoaderContext } from '../contexts/PageLoaderContext'
import useEvents from '../hooks/useEvents'
import usePagination from '../hooks/usePagination'

interface EventsProps {
  isCurrent?: boolean
}

const Events: React.FC<EventsProps> = ({ isCurrent = true }) => {
  const { setLoading: setPageLoading } = useContext(PageLoaderContext)
  const { events, apiLoading, apiError, apiLoadMore, apiLoadingMore } =
    useEvents(isCurrent)
  const { setTriggerElement } = usePagination(apiLoadMore)

  useEffect(() => {
    let didCancel = false

    if (didCancel) return

    setPageLoading(apiLoading)
    return () => {
      didCancel = true
    }
  })

  return (
    <Section>
      <EventList
        {...{
          events,
          apiError,
          apiLoading,
          apiLoadingMore,
          isCurrent,
          onTriggerElement: setTriggerElement,
        }}
      />
    </Section>
  )
}

export default Events
